import Icon from '../atomic/Icon'
import Link from 'next/link'
import React from 'react'
import Trans from '../atomic/Trans'

const Privacy = ({ formik, isRegistrazione = true }) => {
  return (
    <>
      {isRegistrazione && (
        <>
          {/* <p className="registrazione-page__privacy-text">
            <Trans
              chiave="Il consenso è liberamente espresso ai sensi dell’art 23 del DL 196/03 e dell’Art. 7 del
            Reg UE 679/16"
            />
          </p> */}
          <label className="w-form__checkbox-wrapper" htmlFor="privacy">
            <input
              type="checkbox"
              id="privacy"
              name="privacy"
              checked={formik.values.privacy}
              onChange={formik.handleChange}
            />
            <span className="w-form__styled-input">
              <Icon id="check2" />
            </span>
            <span>
              <Trans chiave="Ho letto e compreso l’" />
              <Link legacyBehavior href="/privacy-policy">
                <a className="w-form__privacy-link">informativa privacy</a>
              </Link>{' '}
              <Trans chiave="e accetto integralmente i Termini d’uso." />
            </span>
            <span className="w-form__error">{formik.errors.privacy}</span>
          </label>
        </>
      )}
      <label className="w-form__checkbox-wrapper" htmlFor="commerciale">
        <input
          type="checkbox"
          id="commerciale"
          name="commerciale"
          checked={formik.values.commerciale}
          onChange={formik.handleChange}
        />
        <span className="w-form__styled-input">
          <Icon id="check2" />
        </span>
        <span>
          <Trans
            chiave="Accetto il trattamento dei dati, per la durata prevista dall'informativa, per restare
          aggiornato su novità e promozioni dalle aziende del Gruppo Giunti."
          />
        </span>
      </label>

      <label className="w-form__checkbox-wrapper" htmlFor="profilazione">
        <input
          type="checkbox"
          id="profilazione"
          name="profilazione"
          checked={formik.values.profilazione}
          onChange={formik.handleChange}
        />
        <span className="w-form__styled-input">
          <Icon id="check2" />
        </span>
        <span>
          <Trans chiave="Accetto la profilazione dei dati per ricevere un servizio maggiormente personalizzato." />
        </span>
      </label>
    </>
  )
}

export default Privacy
